var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "selectListContent" }, [
    _vm.type !== "permissionDimension"
      ? _c("div", { staticClass: "select-list-title" }, [
          _vm._v(" " + _vm._s(_vm.title) + " "),
        ])
      : _c("div", { staticClass: "select-list-title" }, [_vm._t("default")], 2),
    _c(
      "div",
      [
        _c("el-input", {
          attrs: {
            placeholder: "请输入搜索内容",
            "suffix-icon": "el-icon-search",
            clearable: "",
          },
          on: { input: _vm.search },
          model: {
            value: _vm.message,
            callback: function ($$v) {
              _vm.message = $$v
            },
            expression: "message",
          },
        }),
      ],
      1
    ),
    _vm.dataList.length !== 0
      ? _c("div", { staticClass: "seleceListBox" }, [
          _c(
            "ul",
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "overflow-hidden",
                  class: {
                    "selectList-selected": item.id === _vm.selectRow.id,
                    selected: item.functionAuthorized === "1",
                  },
                  on: { click: () => _vm.selectItem(item) },
                },
                [_vm._v(" " + _vm._s(item[_vm.label]) + " ")]
              )
            }),
            0
          ),
        ])
      : _c("div", { staticClass: "selectList-empty" }, [
          _vm._v(" 当前暂无数据 "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }